import PromoterCardView from './PromoterCardView.js';
import { useData } from '../context/DataContext.js';

export default function Promoters() {
  const { promoters, events: countryFilteredEvents, loading, error } = useData();

  // Filter promoters to only show those with events
  const activePromoters = promoters?.filter(promoter => 
    countryFilteredEvents?.some(event => event.BusinessName === promoter.BusinessName)
  );

  if (loading) {
    return (
      <div className="relative isolate px-2 pt-6 lg:px-8 h-full">
        <div className="mx-auto max-w-7xl px-2 lg:px-8 pt-6">
          <p>Loading promoters...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="relative isolate px-2 pt-6 lg:px-8 h-full">
        <div className="mx-auto max-w-7xl px-2 lg:px-8 pt-6">
          <p>Error loading promoters: {error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="relative isolate px-2 pt-6 lg:px-8 h-full">
      <div className="mx-auto max-w-7xl px-2 lg:px-8 pt-6">
        <div className="sm:flex sm:items-center"></div>
        <div className="mt-8">
          {activePromoters?.length > 0 ? (
            <PromoterCardView promoters={activePromoters} />
          ) : (
            <h2 className="text-2xl font-bold text-white">No active promoters found</h2>
          )}
        </div>
      </div>
    </div>
  );
} 
